import React from "react";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";
import "./RelatorioAnaliseCriticaDirecaoPrint.css";

function valor(conteudo, fallback = "-") {
  const texto = String(conteudo ?? "").trim();
  return texto || fallback;
}

function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

function Campo({ titulo, conteudo }) {
  return (
    <div className="acd-campo">
      {titulo && <h3>{titulo}</h3>}
      <div className="acd-texto">{valor(conteudo)}</div>
    </div>
  );
}

function Subitem({ titulo, conteudo }) {
  return (
    <div className="acd-subitem">
      <h4>• {titulo}:</h4>
      <div className="acd-texto">{valor(conteudo)}</div>
    </div>
  );
}

function imprimir(codigo) {
  document.title = String(codigo || "RQ-1.5-ANALISE-CRITICA");
  window.print();
}

export default function RelatorioAnaliseCriticaDirecaoPrint({ registro, onVoltar }) {
  useNomeArquivoPdf(registro?.codigo || "RQ-1.5-ANALISE-CRITICA");
  if (!registro) return null;

  return (
    <div className="relatorio-analise-critica-direcao-print">
      <div className="acd-acoes-print">
        {onVoltar && <button onClick={onVoltar}>Voltar</button>}
        <button className="acd-btn-imprimir" onClick={() => imprimir(registro.codigo)}>Imprimir</button>
      </div>

      <article className="acd-pagina">
        <table className="acd-cabecalho">
          <tbody>
            <tr>
              <td rowSpan="2" className="acd-logo-cell"><LogoRelatorio alt="Logo" className="acd-logo" /></td>
              <td className="acd-titulo"><strong>RELATÓRIO DE ANÁLISE<br />CRÍTICA DO SGQ</strong></td>
              <td rowSpan="2" className="acd-codigo">
                <strong>RQ 1.5</strong>
                <span>Versão {valor(registro.versao)}</span>
                <span>Aprovado em<br />{formatarDataBR(registro.aprovadoEm)}</span>
              </td>
            </tr>
            <tr><td className="acd-subtitulo">Sistema de Gestão da Qualidade</td></tr>
          </tbody>
        </table>

        <section>
          <h2>1. Objetivo</h2>
          <Campo conteudo={registro.objetivo} />
        </section>

        <section>
          <h2>2. Estrutura da Reunião (Entradas - ISO 9001:2015, 9.3.2)</h2>
          <Campo titulo="2.1 Situação das ações de análises críticas anteriores" conteudo={registro.situacaoAcoesAnteriores} />
          <div className="acd-campo acd-grupo-mudancas">
            <h3>2.2 Mudanças no contexto da organização</h3>
            <Subitem titulo="Internas" conteudo={registro.mudancasInternas} />
            <Subitem titulo="Externas" conteudo={registro.mudancasExternas} />
            <Subitem titulo="Ambientais" conteudo={registro.mudancasAmbientais} />
          </div>
          <Campo titulo="2.3 Desempenho e eficácia do SGQ" conteudo={registro.desempenhoEficacia} />
          <Campo titulo="2.4 Feedback das partes interessadas" conteudo={registro.feedbackPartesInteressadas} />
          <Campo titulo="2.5 Conformidade de produtos e serviços" conteudo={registro.conformidadeProdutosServicos} />
          <Campo titulo="2.6 Desempenho de fornecedores externos" conteudo={registro.desempenhoFornecedores} />
          <Campo titulo="2.7 Adequação de recursos" conteudo={registro.adequacaoRecursos} />
          <Campo titulo="2.8 Eficácia das ações para lidar com riscos e oportunidades" conteudo={registro.eficaciaRiscosOportunidades} />
          <Campo titulo="2.9 Oportunidades de melhoria" conteudo={registro.oportunidadesMelhoria} />
        </section>

        <section>
          <h2>3. Saídas da Análise Crítica (ISO 9001:2015, 9.3.3)</h2>
          <Campo titulo="3.1 Melhoria do SGQ e Processos" conteudo={registro.melhoriaSGQProcessos} />
          <Campo titulo="3.2 Melhoria de Produtos e Serviços" conteudo={registro.melhoriaProdutosServicos} />
          <Campo titulo="3.3 Necessidades de Recursos" conteudo={registro.necessidadesRecursos} />
          <Campo titulo="3.4 Alinhamento Estratégico" conteudo={registro.alinhamentoEstrategico} />
        </section>

        <section>
          <h2>4. Documentos de Referência já Desenvolvidos</h2>
          <Campo conteudo={registro.documentosReferencia} />
        </section>

        <section>
          <h2>5. Análise de Itens Avançados</h2>
          <Campo conteudo={registro.itensAvancados} />
        </section>

        <section>
          <h2>Conclusão</h2>
          <Campo conteudo={registro.conclusao} />
          <div className="acd-fechamento">
            <div><strong>Data:</strong> {formatarDataBR(registro.dataReuniao)}</div>
            <div><strong>Participantes:</strong> {valor(registro.participantes)}</div>
            <div><strong>Aprovação da direção:</strong> {valor(registro.aprovacaoNome)} - {formatarDataBR(registro.aprovacaoData)}</div>
          </div>
        </section>

        <footer>Registro da Qualidade - Sistema de Gestão da Qualidade</footer>
      </article>
    </div>
  );
}
